/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveCardholderAgreementDocumentRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveCardholderAgreementDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCardholderAgreementDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveCardholderAgreementDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveCardholderAgreementDocumentRequest @ squareup/corporate_card/service/retrieve_cardholder_agreement_document.proto at 10:1
 */
export const RetrieveCardholderAgreementDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrieveCardholderAgreementDocumentRequest');
fixType(RetrieveCardholderAgreementDocumentRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveCardholderAgreementDocumentRequest);
/**
 * SOURCE RetrieveCardholderAgreementDocumentResponse @ squareup/corporate_card/service/retrieve_cardholder_agreement_document.proto at 19:1
 */
export const RetrieveCardholderAgreementDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrieveCardholderAgreementDocumentResponse');
fixType(RetrieveCardholderAgreementDocumentResponse);
Builder.createAndAttachToType(RetrieveCardholderAgreementDocumentResponse);